// ...existing imports...
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { DcpService } from "src/app/services/dcp/dcp.service";
import { PerforatedService } from "../../perforated-pipe/services/perforated.service";
import { SlottedService } from "../../slotted-pipe/services/slotted.service";
import { DcpFilterComponent } from "./components/dcp-filter/dcp-filter.component";
import { Datasheet, SearchItemsRequest } from "./models/dcp-modal";
import { GeothermalService } from "src/app/modules/geothermal/services/geothermal.service";
import { AdvancedpipeService } from "src/app/modules/advancedpipe/services/advancedpipe.service";
import { UnitSystem } from "src/app/shared/enums/unit-system.enum";
import { DataService } from "src/app/services/Data.service";

@Component({
  selector: "app-slotted-modal",
  templateUrl: "./slotted-modal.component.html",
  styleUrls: ["./slotted-modal.component.css"],
})
export class SlottedModalComponent implements OnInit {
  searchItemsRequest: SearchItemsRequest;
  dcpProducs: Datasheet[];
  selectedProduct: Datasheet | null = null;
  canSimulateUserRole: boolean = false;
  simulateUserRole: boolean = false;

  @ViewChild(DcpFilterComponent) dcpFilterComponent: DcpFilterComponent;
  @ViewChild('closeDcpModal') closeDcpModal: ElementRef;

  constructor(
    public dcpService: DcpService, 
    private slottedService: SlottedService, 
    private perforatedService: PerforatedService, 
    private geothermalService: GeothermalService,
    private advancedpipeService: AdvancedpipeService,
    private dataService: DataService
  ) { }
  onFiltersChanged() {
    this.selectedProduct = null;
  }
  ngOnInit() {
    // Check user permissions
    this.dataService.currentRolSource.subscribe((role) => {
      this.canSimulateUserRole = role.some(x => x == "ADMIN") || role.some(x => x == "SUPER_USER");
    });

    [
      this.slottedService.closeDcpModal$,
      this.perforatedService.closeDcpModal$,
      this.geothermalService.closeDcpModal$,
      this.advancedpipeService.closeDcpModal$
    ].forEach(obs => {
      obs.subscribe((closeDcpModal) => {
        if (closeDcpModal) this.closeModal();
      });
    });
  }

  onSimulateUserRoleChange() {
    this.dcpFilterComponent.updateSimulateUserRole(this.simulateUserRole);
  }

  preloadFilters(filterValues: any, unitSystem = UnitSystem.USC, reset = false) {
    this.selectedProduct = null;
    this.dcpFilterComponent.preloadFilters(filterValues, unitSystem, reset);
  }

  onRowSelected(product: Datasheet) {
    this.selectedProduct = product;
  }

  onDoubleClickLoad(product: Datasheet) {
    this.selectedProduct = product;
    this.loadSelectedProduct();
  }

  loadSelectedProduct() {
    if (this.selectedProduct) {
      this.slottedService.setDcpProduct(this.selectedProduct);
      this.perforatedService.setDcpProduct(this.selectedProduct);
      this.geothermalService.setDcpProduct(this.selectedProduct);
      this.advancedpipeService.setDcpProduct(this.selectedProduct);
      this.closeModal();
    } else {
      console.error('SlottedModal - No product selected');
    }
  }

  closeModal() {
    this.closeDcpModal.nativeElement.click();
  }
}
